import Vue from 'vue'
import { AclInstaller, AclCreate, AclRule } from 'vue-acl'
import router from '@/router'

Vue.use(AclInstaller)

var permissionArray = function(){
  if(localStorage.getItem('permissions'))
    return localStorage.getItem('permissions').split(",");
  else{
    localStorage.setItem('permissions', '');
    return localStorage.getItem('permissions').split(",");
  }
}

export default new AclCreate({
  initial: permissionArray(),
  notfound: '/not-authorized',
  router,
  acceptLocalRules: false,
  globalRules: {
    Login: new AclRule('Login').generate(),
    MaintainSites : new AclRule('MaintainSites').generate(),
    MaintainUsers: new AclRule('MaintainUsers').generate(),
    MaintainBackgrounds: new AclRule('MaintainBackgrounds').generate(),
    MaintainMusic: new AclRule('MaintainMusic').generate(),
    MaintainScenes: new AclRule('MaintainScenes').generate(),
    MaintainCharacters: new AclRule('MaintainCharacters').generate(),
    MaintainVideos: new AclRule('MaintainVideos').generate(),
    BuildCourses: new AclRule('BuildCourses').generate(),
    MaintainISpringQuizzes: new AclRule('MaintainISpringQuizzes').generate(),
    MaintainISpringPresentations: new AclRule('MaintainISpringPresentations').generate(),
    MaintainDocuments: new AclRule('MaintainDocuments').generate(),
    MaintainNavigations: new AclRule('MaintainNavigations').generate(),
    MaintainQuizzes: new AclRule('MaintainQuizzes').generate(),
    ViewCourses: new AclRule('ViewCourses').generate(),
    AssessModerate: new AclRule('AssessModerate').generate(),
    Assess: new AclRule('Assess').generate(),
    Moderate: new AclRule('Moderate').generate(),
    ReviewVideos: new AclRule('ReviewVideos').generate(),
    MaintainLanguages: new AclRule('MaintainLanguages').generate(),
    MaintainClassifications: new AclRule('MaintainClassifications').generate(),
    MaintainModuleGroups: new AclRule('MaintainModuleGroups').generate(),
    MaintainMarketingVideos: new AclRule('MaintainMarketingVideos').generate(),
    AssessModerateEvaluate: new AclRule('AssessModerateEvaluate').generate(),
    Evaluate: new AclRule('Evaluate').generate(),
    ViewReports: new AclRule('ViewReports').or('Monitor').generate(),
    MaintainDocumentTypes: new AclRule('MaintainDocumentTypes').generate(),
    MaintainAssessmentQuestions: new AclRule('MaintainAssessmentQuestions').generate(),
    MaintainLibraryResources: new AclRule('MaintainLibraryResources').generate(),
    Student: new AclRule('Student').generate(),
    Teacher: new AclRule('Teacher').generate(),
    Librarian: new AclRule('Librarian').generate(),
    SuperAdmin: new AclRule('SuperAdmin').generate(),
    SiteAdmin: new AclRule('SiteAdmin').or('SuperAdmin').generate(),
    CourseBuilder: new AclRule('CourseBuilder').generate(),
    Assessor: new AclRule('Assessor').generate(),
    Moderator: new AclRule('Moderator').generate(),
    Evaluator: new AclRule('Evaluator').generate(),
    VideoEditor: new AclRule('VideoEditor').generate(),
    Marketer: new AclRule('Marketer').generate(),
    LibraryAdmin: new AclRule('LibraryAdmin').generate(),
    Mentor: new AclRule('Mentor').generate(),
    ViewDashboard: new AclRule('CourseBuilder').or('SuperAdmin').or('SiteAdmin').or('Assessor').or('Moderator').or('Evaluator').or('VideoEditor').or('Marketer').or('LibraryAdmin').or('Mentor').or('Monitor').generate(),
    MaintainPracticalQuestions: new AclRule('MaintainPracticalQuestions').generate(),
    School: new AclRule('School').and('SiteAdmin').generate(),
    Other: new AclRule('Other').and('SiteAdmin').generate(),
    Guardian: new AclRule('Guardian').generate(),
    CEPAdmin: new AclRule('CEPAdmin').generate(),
    MaintainVendors: new AclRule('MaintainVendors').generate(),
    Monitor: new AclRule('Monitor').generate(),
    Principal: new AclRule('Principal').generate()
  },
})